import { TESTIMONIALS } from "@/data/content";
import { Quote } from "lucide-react";

const MARQUEE_WORDS = [
  "COACHING",
  "NUTRITION",
  "RESULTS",
  "OPTIMIZATION",
  "PEPTIDES",
  "RECOVERY",
  "PERFORMANCE",
  "LONGEVITY",
];

export default function Results() {
  return (
    <section
      id="results"
      data-testid="results-section"
      className="relative bg-ng-bg py-24 md:py-36 border-t border-ng-line overflow-hidden hex-bg-strong"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 relative z-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-14">
          <div className="max-w-2xl">
            <div className="label-eyebrow mb-5">05 · Real Progress</div>
            <h2 className="font-display font-bold uppercase text-4xl md:text-6xl tracking-tight text-white leading-[0.95]">
              Results that <br />
              <span className="text-ng-blue italic">speak for themselves</span>.
            </h2>
          </div>
          <p className="text-white/65 max-w-md font-light">
            Real bodies. Real bloodwork. Real lives rebuilt around peak performance.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t) => (
            <TestimonialCard key={t.id} t={t} />
          ))}
        </div>

        {/* Marquee strip */}
        <div className="mt-20 overflow-hidden border-y border-ng-line py-6">
          <div className="marquee-track flex gap-12 whitespace-nowrap">
            {[...Array(2)].map((_, i) => (
              <div
                key={i}
                className="flex gap-12 items-center text-white/30 font-display font-bold italic text-2xl tracking-wider"
              >
                {MARQUEE_WORDS.flatMap((w) => [
                  <span key={`${i}-${w}`}>{w}</span>,
                  <span key={`${i}-${w}-dot`} className="text-ng-blue/60">
                    ◆
                  </span>,
                ])}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function TestimonialCard({ t }) {
  return (
    <div
      data-testid={`testimonial-${t.id}`}
      className="relative bg-ng-surface border border-ng-line p-8 md:p-10 hover:border-ng-blue/40 hover:-translate-y-1 transition-all duration-500 flex flex-col h-full"
    >
      <div className="absolute top-0 left-0 w-10 h-10 border-t border-l border-ng-blue/60" />
      <div className="absolute bottom-0 right-0 w-10 h-10 border-b border-r border-ng-blue/60" />
      <Quote size={28} strokeWidth={1.5} className="text-ng-blue/50 mb-6" />
      <p className="text-white/85 font-light leading-relaxed text-base md:text-lg flex-1">
        &ldquo;{t.quote}&rdquo;
      </p>
      <div className="mt-8 pt-6 border-t border-white/5 flex items-center justify-between">
        <div>
          <div className="text-white font-display font-bold uppercase tracking-wider">
            {t.name}
          </div>
          <div className="label-muted mt-1">{t.role}</div>
        </div>
        <div className="text-right">
          <div className="font-display font-bold text-ng-blue text-sm tracking-wider">
            {t.metric}
          </div>
        </div>
      </div>
    </div>
  );
}
